<app-page-meta pageTitle="finzy - Loan Application Status"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12 col-md-10 col-md-offset-1">

      <div class="text-center mt-3">
        <app-display-picture [userId]="userId"></app-display-picture>
        <p class="finzy-txt-p">{{name}}</p>
        <p class="finzy-txt-loan">{{loanStatus}}</p>
      </div>

      <div class="row finzy-row2" *ngIf="ifSanctioned">
        <p class="finzy-txt-p">OFFER VALID TILL <span
            style="text-transform: uppercase;">{{offerTime | date}}</span></p>

        <div class="row finzy-row3 loan-details-cont">
          <div *ngIf="!hideEmiAmount" class="col-sm-4">
            <p class="finzy-p1">₹ <app-horizontal-loader *ngIf="emi_amount === undefined || emi_amount === null"></app-horizontal-loader>{{emi_amount | number : fractionSize}} </p>

            <p class="finzy-p2">EMI</p>
          </div>
          <div *ngIf="!hideLoanTenure" class="col-sm-3">
            <p class="finzy-p1">{{loan_tenure}} </p>
            <p class="finzy-p2">MONTHS</p>
          </div>
          <div class="col-sm-5 perROI">

            <div><p class="finzy-p1">
              <app-horizontal-loader *ngIf="emi_amount === undefined || emi_amount === null"></app-horizontal-loader>
              <span *ngIf="emi_amount !== undefined && emi_amount !== null">{{roi}}%</span>
            </p>
            </div>
            <div><p class="finzy-p2">PERSONALISED RATE OF INTEREST</p></div>
          </div>

          <div class="row finzy-row6" *ngIf="errorEmail">
            <p class="finzy-red">It seems you may have missed verifying your email address, </p>
            <p class="finzy-red">Please check your registered email id and click on “verify”</p>
            <div class="btn-class3">
              <button mat-flat-button class="primary" (click)="reSendEmail($event)">RE-SEND EMAIL VERIFICATION</button>
              <p class="finzy-green" *ngIf="resendEmail">Email successfully resent to {{email |
                slice:0:6}}xxxxxxxxxxx{{email | slice:-6}}</p>
            </div>
          </div>

        </div>


        <div *ngIf="showAcceptBtn" class="mt-5">
          <button mat-flat-button class="primary" *ngIf="acceptOfferBtn" (click)="acceptOffer($event)">ACCEPT THIS
            OFFER
          </button>
          <div class="loader" *ngIf="loader">
            <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
          </div>
        </div>

      </div>

      <div class="row finzy-row2" *ngIf="ifNotSanctioned">
        <i class="material-icons clock">access_time</i>
        <p class="finzy-p61">Your application is under processing. </p>
        <p class="finzy-p61">We will revert with our credit decision within <b>1 business day</b>.</p>
        <p class="finzy-p61">We will ensure that you get the best customized rate at the earliest.</p>
      </div>

      <div class="row finzy-row41" *ngIf="ifNotSanctioned">
        <p class="finzy-p6" *ngIf="otherDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/partnerfaq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 800 800. We are always happy to help!</p>

        <p class="finzy-p6" *ngIf="finzyDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/faq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>

      <div class="row finzy-row2" *ngIf="ifRejected">
        <i class="material-icons clock">access_time</i>
        <p class="finzy-p61">You can apply for a new loan </p>
      </div>

      <div class="row finzy-row41" *ngIf="ifRejected">
        <p class="finzy-p6" *ngIf="otherDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/partnerfaq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 800 800. We are always happy to help!</p>

        <p class="finzy-p6" *ngIf="finzyDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/faq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>

      <div class="row finzy-row4" *ngIf="ifSanctioned">
        <p class="finzy-p3">Accepting this offer enables this loan request to be listed. </p>
        <p class="finzy-p3">Listing allows lenders to view your requests and fulfill them. Typically loans are fulfilled
          in 10 days.</p>
        <p class="finzy-p4" *ngIf="otherDomain">This loan amount will be disbursed to {{partnerName}}</p>
        <p class="finzy-p4" *ngIf="finzyDomain">Your loan amount will be disbursed to your bank account which you have
          provided in the bank statement</p>

        <button mat-stroked-button class="primary my-4" *ngIf="hideRejectBtn" (click)="openDialog()">REJECT OFFER</button>

        <p class="finzy-p6" *ngIf="otherDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/partnerfaq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 800 800. We are always happy to help!</p>

        <p class="finzy-p6" *ngIf="finzyDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/faq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>

    </div>
  </div>
</div>
